import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { DailyReportFormModel } from '../../models';

export const getDefaultValues = (globalSettings: GlobalSettingsModel): DailyReportFormModel => ({
  day: globalSettings?.frontend_date,
  comment: '',
  file_type: 'pdf',
});
